window.flash = (message, type) => {
    EventBus.$emit('flash_' + type, { message });
};

window.flash_success = (message = 'Ändringar sparade') => {
    flash(message, 'success');
};

window.flash_message = (message) => {
    flash(message, 'message');
};

window.flash_error = (message) => {
    flash(message, 'error');
};

window.clear_flash_errors = () => {
    EventBus.$emit('clear-errors');
};
